import { Header } from "@/components/sections/Header";
import { Hero } from "@/components/sections/Hero";
import { HeroTestimonial } from "@/components/sections/HeroTestimonial";
import { TrustBar } from "@/components/sections/TrustBar";
import { GoogleReviews } from "@/components/sections/GoogleReviews";
import { ServicesInclude } from "@/components/sections/ServicesInclude";
import { SeoContent } from "@/components/sections/SeoContent";
import { Industries } from "@/components/sections/Industries";
import { DetailedServices } from "@/components/sections/DetailedServices";
import { PricingCalculator } from "@/components/sections/PricingCalculator";
import { Gallery } from "@/components/sections/Gallery";
import { SupplyBanner } from "@/components/sections/SupplyBanner";
import { Testimonials } from "@/components/sections/Testimonials";
import { OwnersBanner } from "@/components/sections/OwnersBanner";
import { ServiceAreas } from "@/components/sections/ServiceAreas";
import { Faq } from "@/components/sections/Faq";
import { ContactForm } from "@/components/sections/ContactForm";
import { Footer } from "@/components/sections/Footer";
import { StickyCallBar } from "@/components/sections/StickyCallBar";
import { OfferModal } from "@/components/sections/OfferModal";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-white">
      <Header />
      <main>
        <Hero />
        <HeroTestimonial />
        <TrustBar />
        <GoogleReviews />
        <ServicesInclude />
        <SeoContent />
        <Industries />
        <DetailedServices />
        <PricingCalculator />
        <Gallery />
        <SupplyBanner />
        <Testimonials />
        <OwnersBanner />
        <ServiceAreas />
        <Faq />
        <ContactForm />
      </main>
      <Footer />
      <StickyCallBar />
      <OfferModal />
    </div>
  );
}
